import { render, staticRenderFns } from "./ResendTokenEmail.vue?vue&type=template&id=8d516340&"
import script from "./ResendTokenEmail.vue?vue&type=script&lang=js&"
export * from "./ResendTokenEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResendTokenEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports